import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const FacebookLogo = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 13}
        height={size ?? 23}
        viewBox="0 0 13 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
        ref={ref}
      >
        <path
          d="M8.02462 22.7499V12.4865H11.4696L11.9854 8.48672H8.02462V5.93297C8.02462 4.77496 8.34622 3.98572 10.007 3.98572L12.125 3.98478V0.40743C11.0999 0.298951 10.0695 0.246396 9.03866 0.249998C5.9849 0.249998 3.89423 2.11392 3.89423 5.53709V8.48684H0.440308V12.4866H3.89413V22.75L8.02462 22.7499Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default FacebookLogo;
